var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBulletPoint = function SvgBulletPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bullet-point_svg__a)",
    fillRule: "evenodd",
    d: "M10 5.833a4.167 4.167 0 1 0 0 8.334 4.167 4.167 0 0 0 0-8.334M10 7.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bullet-point_svg__a",
    x1: 10.001,
    x2: 10.001,
    y1: 14.167,
    y2: 5.833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A7DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#00CDDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01DCCF"
  })))));
};
export default SvgBulletPoint;